const REPLACEMENT_STRING = "--";

export function guardString(input: unknown, fallback = REPLACEMENT_STRING): string {
	if (!input && input !== "0" && input !== 0) return fallback;
	if (typeof input === "string") return input;
	if (typeof input === "number") return input.toString();
	if (typeof input === "boolean") return input.toString();
	if (typeof input === "object") return fallback;
	return fallback;
}
